<div *ngIf="!showV2" class="row {{ customClass }}">
  <div class="col">
    <div class="table-responsive gung-responsive">
      <table class="table table-striped table-hover">
        <thead class="">
          <tr>
            <!-- <th scope="col" translate>#</th> -->
            <ng-container *ngFor="let column of columns">
              <th
                *ngIf="column.type !== EdiRowTableType.TABLE"
                scope="col"
                [ngClass]="{ 'w-1perc': column.type === EdiRowTableType.IMAGE }"
                translate
              >
                {{ column.header }}
              </th>
            </ng-container>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let row of table; index as idx">
            <tr [class]="rowClasses[idx]">
              <!-- <th scope="row" [attr.data-label]="'#' | translate">{{idx}}</th> -->
              <td *ngFor="let column of row" [attr.data-label]="column.header | translate" [class]="column.customClass">
                <ng-container [ngSwitch]="column.type">
                  <ng-template [ngSwitchCase]="EdiRowTableType.TEXT">{{ column.value }}</ng-template>
                  <ng-template [ngSwitchCase]="EdiRowTableType.NUMBER">{{ column.value | number }}</ng-template>
                  <ng-template [ngSwitchCase]="EdiRowTableType.NUMBER">{{
                    column.value | date: dateUtilService.dateFormat
                  }}</ng-template>
                  <ng-template [ngSwitchCase]="EdiRowTableType.HTML"
                    ><div [innerHTML]="column.value | safeHtml"></div
                  ></ng-template>
                  <ng-template [ngSwitchCase]="EdiRowTableType.IMAGE">
                    <img
                      style="width: 120px; height: 120px;"
                      *ngIf="column.value?.length > 0 && column.value[0] as image; else noimage"
                      [src]="image.s3Uri | gungImageUrl
                        :'type:list'
                        :'etag:'+image.s3ETag
                      "
                      alt="{{ image.description }}"
                      class="img-fluid mw-unset"
                    />
                    <ng-template #noimage>
                      <img
                        style="width: 120px; height: 120px;"
                        [src]="'images/no-image.jpg' | gungImageUrl"
                        alt="NO IMAGE"
                        class="img-fluid mw-unset"
                      />
                    </ng-template>
                  </ng-template>
                  <ng-template [ngSwitchCase]="EdiRowTableType.ACTION">
                    <button
                      *ngFor="let action of column.value"
                      type="button"
                      (click)="action.getValue(column.data)"
                      [class]="action.customClass || 'btn btn-info btn-sm'"
                      translate
                    >
                      {{ action.header }}
                    </button>
                  </ng-template>
                  <ng-template ngSwitchDefault>{{ column.value }}</ng-template>
                </ng-container>
              </td>
            </tr>
            <!-- SECONDARY TABLE -->
            <ng-container *ngFor="let secondary of secondaryTable[idx]">
              <tr *ngIf="secondary.data?.length > 0">
                <td [attr.colspan]="columns.length">
                  <lib-edi-row-table [data]="secondary.data" [columns]="secondary.columns" [customClass]="secondary.customClass"></lib-edi-row-table>
                </td>
              </tr>
            </ng-container>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>
</div>

<!-- V2 Bootstrap Table -->
<div *ngIf="showV2" class="row {{ customClass }}">
  <div class="col">
    <div class="table-responsive gung-responsive">
      <table class="table table-striped table-hover">
        <thead>
          <tr>
            <ng-container *ngFor="let column of columns">
              <th
                *ngIf="column.type !== EdiRowTableType.TABLE"
                scope="col"
                [ngClass]="{ 'w-1perc': column.type === EdiRowTableType.IMAGE }"
                translate
              >
                {{ column.header }}
              </th>
            </ng-container>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let row of table; index as idx">
            <tr [class]="rowClasses[idx]">
              <td *ngFor="let column of row" [attr.data-label]="column.header | translate" [class]="column.customClass">
                <ng-container [ngSwitch]="column.type">
                  <ng-template [ngSwitchCase]="EdiRowTableType.TEXT">{{ column.value }}</ng-template>
                  <ng-template [ngSwitchCase]="EdiRowTableType.NUMBER">{{ column.value | number }}</ng-template>
                  <ng-template [ngSwitchCase]="EdiRowTableType.DATE">{{ column.value | date: dateUtilService.dateFormat }}</ng-template>
                  <ng-template [ngSwitchCase]="EdiRowTableType.HTML">
                    <div [innerHTML]="column.value | safeHtml"></div>
                  </ng-template>
                  <ng-template [ngSwitchCase]="EdiRowTableType.IMAGE">
                    <img
                      style="width: 120px; height: 120px;"
                      *ngIf="column.value?.length > 0 && column.value[0] as image; else noimageV2"
                      [src]="image.s3Uri | gungImageUrl
                        :'type:list'
                        :'etag:'+image.s3ETag
                      "
                      alt="{{ image.description }}"
                      class="img-fluid mw-unset"
                    />
                    <ng-template #noimageV2>
                      <img
                        style="width: 120px; height: 120px;"
                        [src]="'images/no-image.jpg' | gungImageUrl"
                        alt="NO IMAGE"
                        class="img-fluid mw-unset"
                      />
                    </ng-template>
                  </ng-template>
                  <ng-template [ngSwitchCase]="EdiRowTableType.ACTION">
                    <button
                      *ngFor="let action of column.value"
                      type="button"
                      (click)="action.getValue(column.data)"
                      [class]="action.customClass || 'btn btn-info btn-sm'"
                      translate
                    >
                      {{ action.header }}
                    </button>
                  </ng-template>
                  <ng-template ngSwitchDefault>{{ column.value }}</ng-template>
                </ng-container>
              </td>
            </tr>
            <!-- SECONDARY TABLE -->
            <ng-container *ngFor="let secondary of secondaryTable[idx]">
              <tr *ngIf="secondary.data?.length > 0">
                <td [attr.colspan]="columns.length">
                  <lib-edi-row-table [data]="secondary.data" [columns]="secondary.columns" [customClass]="secondary.customClass"></lib-edi-row-table>
                </td>
              </tr>
            </ng-container>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>
</div>
